<template>
  <v-card flat>
    <v-card-text>
      <v-toolbar class="accent">
        Continue as a guest. No login required
      </v-toolbar>
      <v-container fluid>
        <v-layout column class="mt-4">
          <v-flex :class="messageClass">
            <v-text-field
              label="Email"
              v-model="email"
              :rules="[rules.required]"
              type="email"
            >
              Email
            </v-text-field>
          </v-flex>
          <v-flex :class="messageClass">
            <v-text-field
              label="Cell Phone"
              v-model="cell"
              placeholder="555-555-5555"
              required
              mask="###-###-####"
              :rules="[rules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex :class="messageClass">
            <v-text-field
              label="Alternate Phone (optional)"
              v-model="alt"
              placeholder="555-555-5555"
              mask="###-###-####"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Shared from "@/mixins/Shared";

export default {
  name: "LoginGuest",
  mixins: [Shared]
}
</script>
